'use client';

import { Navigate, Outlet } from 'react-router-dom';
import { useAuthData } from '@/hooks/getAuthData';
import { isReportOnlyUser } from '@/utils/roles';

/** Blocks Accounting report-only users from operational Tom's Vending screens. */
export function RequireTomsVendingOperational() {
  const { roles } = useAuthData();

  if (isReportOnlyUser(roles)) {
    return <Navigate to="/app/toms-vending/reports" replace />;
  }

  return <Outlet />;
}
